import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ShareButtonComponent} from './share-button.component';

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [
    ShareButtonComponent,
  ],
  exports: [ShareButtonComponent]
})
export class ShareButtonModule { }
